<template>
    <div class="container">
        <div class="row">
            <div class="medium-12 columns">
                <header class="header-static">
                    <slot />
                    <a
                        v-if="url !== null"
                        class="close-button open-modal"
                        data-test-static-header-close
                        :href="url"
                    >
                        <span class="icon icon-close" />
                    </a>

                    <a
                        v-if="url === null"
                        class="close-button open-modal"
                        data-test-static-header-close
                        @click="$emit('close')"
                    >
                        <span class="icon icon-close" />
                    </a>
                </header>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StaticHeader',
    props: {
        url: {
            type: String,
            default() {
                return null;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import 'src/styles/all.scss';

.header-static {
    display: flex;
    justify-content: center;
    align-items: center;
    height: rem-calc(200);

    @include breakpoint(medium down) {
        height: rem-calc(100);
    }

    .close-button {
        top: 50%;

        @include breakpoint(medium up) {
            top: 50%;
        }
    }
}
</style>
